// show available products
// (function () {
//     const links = document.querySelectorAll('a')
  
//     links.forEach(link => {
//       if (link.getAttribute('href') && link.getAttribute('href').toString().includes("/collections/") && !link.getAttribute('href').toString().includes("/products/")) {
//         const href = link.getAttribute('href')
//         link.setAttribute('href', `${href}?filter.v.availability=1&sort_by=manual`)
//       }
//     });
//   })();
// show available products

// size calculator
(function () {
  if (document.querySelector('.custom-size-block')) {

    if (document.querySelector('.custom-size-calcualtor')) {
      document.querySelector('.custom-size-calcualtor [data-type=button]').addEventListener('click', () => {
        document.querySelector('.custom-size-calcualtor .calculator-popup').classList.add('active')
        document.querySelector('header').classList.add('header-none')
        document.querySelector('body').classList.add('fixedScroll')
      })
    

      document.querySelector('.custom-size-calcualtor .calculator-popup .close').addEventListener('click', () => {
        document.querySelector('.custom-size-calcualtor .calculator-popup').classList.remove('active')
        document.querySelector('header').classList.remove('header-none')
        document.querySelector('body').classList.remove('fixedScroll')
      })

      document.querySelector('.custom-size-calcualtor .calculator-popup .result input').addEventListener('click', () => {
        let growth = parseInt(document.querySelector('.custom-size-calcualtor .calculator-popup input[name=growth]').value);
        let weight = parseInt(document.querySelector('.custom-size-calcualtor .calculator-popup input[name=weight]').value);
        document.querySelector('.custom-size-calcualtor .calculator-popup .result h3').textContent = getSize(growth, weight)
      })
    }
    

    const sizes = [
      ["S", "S", "S", "S", "M", "L", "XL"],
      ["S", "S", "S", "S", "M", "L", "XL"],
      ["S", "S", "S", "S", "M", "L", "XL"],
      ["S", "S", "M", "M", "M", "L", "XL"],
      ["S", "S", "M", "M", "M", "L", "XL"],
      ["M", "M", "M", "M", "L", "L", "XL"],
      ["M", "M", "L", "L", "L", "XL", "XL"],
      ["M", "M", "L", "L", "XL", "XL", "XL"],
      ["M", "M", "L", "L", "XL", "XL", "XL"],
      ["L", "L", "L", "L", "XL", "XL", "XL"],
      ["L", "L", "L", "XL", "XL", "XL", "XL"]
    ];
    function getX(weight) {
      if (55 > weight && weight >= 50) {
        return 0;
      } else if (60 > weight && weight >= 55) {
        return 1;
      } else if (65 > weight && weight >= 60) {
        return 2;
      } else if (70 > weight && weight >= 65) {
        return 3;
      } else if (75 > weight && weight >= 70) {
        return 4;
      } else if (80 > weight && weight >= 75) {
        return 5;
      } else if (85 > weight && weight >= 80) {
        return 6;
      } else if (90 > weight && weight >= 85) {
        return 7;
      } else if (95 > weight && weight >= 90) {
        return 8;
      } else if (100 > weight && weight >= 95) {
        return 9;
      } else if (105 > weight && weight >= 100) {
        return 10;
      } else {
        return null;
      }
    }
    function getY(growth) {
      if (165 > growth && growth >= 160) {
        return 0;
      } else if (170 > growth && growth >= 165) {
        return 1;
      } else if (175 > growth && growth >= 170) {
        return 2;
      } else if (180 > growth && growth >= 175) {
        return 3;
      } else if (185 > growth && growth >= 180) {
        return 4;
      } else if (190 > growth && growth >= 185) {
        return 5;
      } else if (195 > growth && growth >= 190) {
        return 6;
      } else {
        return null;
      }
    }
    function getSize(growth, weight) {

      let x = getX(weight);
      let y = getY(growth);

      if (x !== null && y !== null) {
        return `Розмір - ${sizes[x][y]}`;
      } else {
        return "Вашого розміру немає в наявності";
      }
    }

    
    if (document.querySelector('.custom-size-grid')) {
      document.querySelector('.custom-size-grid [data-type=button]').addEventListener('click', () => {
        document.querySelector('.custom-size-grid .grid-popup').classList.add('active')
        document.querySelector('header').classList.add('header-none')
        document.querySelector('body').classList.add('fixedScroll')
      })

      document.querySelector('.custom-size-grid .grid-popup .close').addEventListener('click', () => {
        document.querySelector('.custom-size-grid .grid-popup').classList.remove('active')
        document.querySelector('header').classList.remove('header-none')
        document.querySelector('body').classList.remove('fixedScroll')
      })
    }
    
    document.querySelectorAll('.custom-size-block').forEach(el => {
      el.addEventListener('click', e => {
        if (e.target.classList.contains('custom-popup')) {
          e.target.classList.remove('active')
          document.querySelector('header').classList.remove('header-none')
          document.querySelector('body').classList.remove('fixedScroll')
        }
      })
    })

    
  }
})();
// size calculator

(function () {
  if (document.querySelector('.product__chast')) {
      if (document.querySelector('.product__chast')) {  
        document.querySelector('.product__chast a').addEventListener('click', () => {
          document.querySelector('.product__chast .chast-popup').classList.add('active')
          document.querySelector('header').classList.add('header-none')
          document.querySelector('body').classList.add('fixedScroll')
        })
      
        document.querySelector('.product__chast .chast-popup .close').addEventListener('click', () => {
          document.querySelector('.product__chast .chast-popup').classList.remove('active')
          document.querySelector('header').classList.remove('header-none')
          document.querySelector('body').classList.remove('fixedScroll')
        })
      }
  
      document.querySelectorAll('.product__chast').forEach(el => {
        el.addEventListener('click', e => {
          if (e.target.classList.contains('custom-popup')) {
            e.target.classList.remove('active')
            document.querySelector('header').classList.remove('header-none')
            document.querySelector('body').classList.remove('fixedScroll')
          }
        })
      })
  }
})();

(function () {
  if (document.querySelector('.banner-form-popup')) {

    document.querySelectorAll('a[href="#banner-form"]').forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        document.querySelector('.banner-form-popup').classList.add('active');
        document.querySelector('header').classList.add('header-none');
        document.querySelector('body').classList.add('fixedScroll');
      });
    });

    document.querySelector('.banner-form-popup .close').addEventListener('click', () => {
      document.querySelector('.banner-form-popup').classList.remove('active');
      document.querySelector('header').classList.remove('header-none');
      document.querySelector('body').classList.remove('fixedScroll');
    });

    document.querySelectorAll('.banner-form-popup').forEach(el => {
      el.addEventListener('click', e => {
        if (e.target.classList.contains('custom-popup')) {
          e.target.classList.remove('active');
          document.querySelector('header').classList.remove('header-none');
          document.querySelector('body').classList.remove('fixedScroll');
        }
      });
    });
  }
})();

// style for sendpulse forms
// (function () {
//   const addStylesToFormFooter = () => {
//     const hostElement = document.querySelector('.new_footer .sp-inline-popup');
//     const shadowRoot = hostElement.shadowRoot;
//     const style = document.createElement('style');
//     style.textContent = `
//       .sp-inline-popup  .sp-popup-popup .sp-popup.sp-popup-subscribe {
//         box-shadow: none !important;
//         border-radius: 0 !important;
//       }
//       .sp-inline-popup  .sp-popup-popup .sp-popup .sp-popup-info {
//         padding: 0 !important;
//       }
//       .sp-inline-popup  .sp-popup-popup .sp-popup .sp-popup-content {
//         border-radius: 0!important;
//       }
//       .sp-inline-popup  .sp-poweredby {
//         display:none !important;
//       }
//       .sp-inline-popup  .sp-popup-popup .sp-popup-form {
//         flex-direction: row !important;
//         gap:0 !important;
//       }
//       .button-group.svelte-1cqpana .sp-popup-button-image.svelte-1cqpana {
//         background-size: 20px !important;
//       }
//       .sp-inline-popup  .sp-submit .sp-submit-animation-circle.sp-submit-anim-checkmark .sp-submit-animation-draw:after {
//         height: 22px !important;
//         width: 15px !important;
//         left: 8px !important;
//         top: 21px !important;
//       }
//       .sp-inline-popup  .sp-submit .sp-submit-animation-circle {
//         height: 45px !important;
//         min-height: 45px !important;
//         min-width: 45px !important;
//         width: 45px !important;
//       }
//       .edu-registration-complete .sp-submit-animation {
//         display:none !important;
//       }
//       .sp-inline-popup  .sp-submit .sp-submit-animation {
//         opacity: 1 !important;
//       }
//       .sp-inline-popup  .sp-popup-input-main.svelte-1pwp4mq .sp-popup-input-placeholder.svelte-1pwp4mq {
//         top:-3px !important;
//       }
//     `;
  
//     shadowRoot.appendChild(style);
//   }
//   const addStylesToFormContacts = () => {
//     const hostElement = document.querySelector('#contact__form .sp-inline-popup');
//     const shadowRoot = hostElement.shadowRoot;
//     const style = document.createElement('style');
//     style.textContent = `
//       .sp-inline-popup  .sp-popup-popup .sp-popup{
//         box-shadow: none !important;
//         border-radius: 0 !important;
//       }
//       .sp-inline-popup  .sp-popup-popup .sp-popup .sp-popup-info {
//         padding: 0 !important;
//         padding-top: 10px !important;
//       }
//       .sp-inline-popup  .sp-popup-popup .sp-popup .sp-popup-content {
//         border-radius: 0 !important;
//       }
//       .sp-inline-popup  .sp-poweredby {
//         display:none !important;
//       }
//       .sp-inline-popup  .sp-popup.sp-popup-theme-white .sp-popup-input-placeholder {
//         color: #000 !important;
//       }
//     `;
  
//     shadowRoot.appendChild(style);
//   }
    

//   function waitForElement(selector, callback) {
//     const observer = new MutationObserver((mutations) => {
//       for (let mutation of mutations) {
//         if (mutation.type === 'childList') {
//           const element = document.querySelector(selector);
//           if (element) {
//             callback(element);
//             observer.disconnect();
//             break;
//           }
//         }
//       }
//     });
  
//     observer.observe(document.documentElement, { childList: true, subtree: true });
//   }
  
//   waitForElement('.new_footer .sp-inline-popup', (element) => {
//     addStylesToFormFooter()
//   });

//   if (document.querySelector('#contact__form')) {
//     waitForElement('.new_footer .sp-inline-popup', (element) => {
//       addStylesToFormContacts()
//     });
//   }
  
// })();
// style for sendpulse forms

// Show more/less text
(function () {
  if (document.querySelector('.toggle-button')) {
    const toggleButtons = document.querySelectorAll('.toggle-button');

    toggleButtons.forEach(button => {
        button.addEventListener('click', function() {
            const textContent = this.previousElementSibling;

            if (textContent.classList.contains('expanded')) {
                textContent.style.maxHeight = '100px'; // Collapsed state height
                textContent.classList.remove('expanded');
                this.textContent = this.dataset.more;
            } else {
                const scrollHeight = textContent.scrollHeight;
                textContent.style.maxHeight = scrollHeight + 'px';
                textContent.classList.add('expanded');
                this.textContent = this.dataset.less;
            }
        });
    });
  }
})();
// Show more/less text

// redirect to COM
// (function () {
//   function redirectToInternationalSite() {
//     const locationKey = 'userLocation';
//     const locationTimeKey = 'userLocationTime';

//     // 👉 Настройки
//     const cacheDays = 7;  // срок хранения (в днях)
//     const redirectUrl = 'https://farfieworldwide.com'; // адрес для редиректа

//     const locationExpiry = cacheDays * 24 * 60 * 60 * 1000;
//     const now = Date.now();

//     // достаём сохранённые данные
//     const userLocation = localStorage.getItem(locationKey);
//     const locationTime = localStorage.getItem(locationTimeKey);

//     if (userLocation && locationTime && (now - locationTime < locationExpiry)) {
//       // если данные ещё актуальны
//       if (userLocation !== 'UA') {
//         window.location.href = redirectUrl;
//       }
//     } else {
//       // если данных нет или срок истёк → запрос к API
//       fetch('https://api.ipregistry.co/?key=ira_pmQVZQ3n1OyRtFIB0u3kVVby66hLZn2HYWTY')
//         .then(response => response.json())
//         .then(data => {
//           const countryCode = data.location.country.code;

//           // сохраняем страну и время в localStorage
//           localStorage.setItem(locationKey, countryCode);
//           localStorage.setItem(locationTimeKey, now);

//           if (countryCode !== 'UA') {
//             window.location.href = redirectUrl;
//           }
//         })
//         .catch(error => {
//           console.error('Error fetching user location:', error);
//         });
//     }
//   }

//   redirectToInternationalSite();
// })();
// redirect to COM

(function () {
  const menuButtonDesktop = document.querySelector('.header__icon--menu_desktop');
  const menuButtonMobile = document.querySelector('.header__icon--menu_mobile');

  menuButtonDesktop.addEventListener('click', () => {
    menuButtonMobile.click();
    menuButtonDesktop.classList.toggle('active');
  });
})();


// document.addEventListener("scroll", function () {
//   const logo = document.querySelector(".sticky-main-logo");
  
//   if (window.scrollY > 400) {
//     logo.classList.add("sticky");
//   } else {
//     logo.classList.remove("sticky");
//   }
// });


// Header transparent
(function () {
  document.addEventListener('DOMContentLoaded', function() {
    const header = document.querySelector('.header-wrapper'); // замени на свой селектор шапки
    const isHome = window.location.pathname === '/'; // только для главной

    if (isHome && header) {
      header.classList.add('header--transparent');

      window.addEventListener('scroll', function() {
        if (window.scrollY > 50) { // отступ, после которого возвращаем цвет
          header.classList.remove('header--transparent');
        } else {
          header.classList.add('header--transparent');
        }
      });
    }
  });

})();
// Header transparent

// product media slider
(function () {
  var swiper2 = new Swiper(".mySwiper2", {
    loop: true,
    spaceBetween: 10,
    pagination: {
      el: ".swiper-pagination",
      type: "fraction",
    }
  });
  var farfiProductSwiperThumbs = new Swiper('.farfi-product-swiper-thumbs',{
    direction: 'vertical',
    loop: true,
    spaceBetween: 20,
    freeMode: true,
    watchSlidesProgress: true,
    slidesPerView: 4,
  });

  // Reinitialize the swiper after changing the settings
  farfiProductSwiperThumbs.init();

  var farfiProductSwiper = new Swiper('.farfi-product-swiper', {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 0,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: ".swiper-pagination",
      type: "fraction",
    },
    thumbs: {
      swiper: farfiProductSwiperThumbs,
    },
  });
})();


document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('productGalleryModal');
  const modalImages = modal.querySelector('.product-gallery-modal__images');
  const closeBtn = modal.querySelector('.product-gallery-modal__close');
  const overlay = modal.querySelector('.product-gallery-modal__overlay');

  const productImages = document.querySelectorAll(
    '.farfi-product-swiper .swiper-slide img'
  );

  const closeModal = () => {
    modal.classList.remove('active');
    document.body.style.overflow = '';
  };

  productImages.forEach((img) => {
    img.addEventListener('click', () => {
      modalImages.innerHTML = '';

      productImages.forEach((image) => {
        const modalImg = document.createElement('img');
        modalImg.src = image.currentSrc || image.src;
        modalImg.alt = image.alt || '';

        // 🔥 закриття по кліку на фото
        modalImg.addEventListener('click', closeModal);

        modalImages.appendChild(modalImg);
      });

      modal.classList.add('active');
      document.body.style.overflow = 'hidden';
    });
  });

  closeBtn.addEventListener('click', closeModal);
  overlay.addEventListener('click', closeModal);
});
// product media slider

// cart drawer related products
(function () {
  document.addEventListener('DOMContentLoaded', function() {
    var allProducts = document.querySelectorAll('.drawer_related_products_slider .swiper-slide');
    var productArray = Array.prototype.slice.call(allProducts);
    var shuffled = productArray.sort(function() { return 0.5 - Math.random() });
    var selected = shuffled.slice(0, 8);

    var container = document.querySelector('.drawer_related_products_slider .swiper-wrapper');
    container.innerHTML = '';
    
    selected.forEach(function(product) {
      product.classList.remove('hidden')
      container.appendChild(product);
    });
    
    var swiper = new Swiper('.drawer_related_products_slider', {
      slidesPerView: 'auto',
        spaceBetween: 10,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }
    });
  });
})();
// cart drawer related products



